import React, { useEffect, useState } from "react";
import AuthHeader from "../../components/Navbar/AuthHeader";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { MdOutlineMarkEmailRead } from "react-icons/md";
import { TbLockCheck } from "react-icons/tb";
import { FcGoogle } from "react-icons/fc";
import { FaFacebook, FaApple } from "react-icons/fa";
import { IoMdEyeOff } from "react-icons/io";
import { IoEye } from "react-icons/io5";
import { loginUser } from "../../actions/auth";
import { PiWarningCircleThin } from "react-icons/pi";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
import GoogleAuth from "../../components/SocialAuth/GoogleAuth";
import { setInactive, clearInactive } from "../../redux/slices/authSlice";

function Login() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [passwordType, setPasswordType] = useState("password");

  const [isLoading, setIsLoading] = useState(false);
  const [successMessage, setSuccessMessage] = useState('');
  const [errorMessage, setErrorMessage] = useState('');

  const logoutAlert = location.state?.inactive;

  const togglePasswordVisibility = () => {
    setPasswordType(passwordType === "password" ? "text" : "password");
  };

  const handleLogin = async (event) => {
    event.preventDefault();

    if (!email || !password) {
      setErrorMessage("All fields are required.");
      return;
    }; 

    setIsLoading(true);
    setErrorMessage('');
    setSuccessMessage('');

    const credentials = {
      email, password
    }

    

    await loginUser(credentials, dispatch, navigate, setSuccessMessage, setErrorMessage, setIsLoading, toast);
  };

  useEffect(() => {
    if (location.state?.inactive) {
      dispatch(setInactive(true));
      // // clear route state
      window.history.replaceState({}, document.title);
    }
    return () => {
      dispatch(clearInactive());
    };
  }, [location.state]);

  return (
    <div style={{  background: "#13053A", minHeight: "100vh", display: "flex", flexDirection: "column", justifyContent: "center" }}>
      <AuthHeader />
      <div className="auth__container padding__tb__30">
        <div className="auth__container__box">

          {logoutAlert && (
            <div className="my-3 mx-3 logout__alert">
              <div className="alert alert-secondary alert-dismissible fade show" role="alert">
                <div className="d-flex align-items-start justify-content-between gap-3"> 
                  <div className="logout__alert__icon"><PiWarningCircleThin size={40} color="" /></div>
                  <p className="mb-0" style={{ fontSize: "14px" }}>
                    You were logged out because you have been inactive for some time. This is to ensure that your account remain secure.
                  </p>
                  <button type="button" className="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>
                </div>
              </div>
            </div>
          )}

          <h3 className="mt-2">Welcome back</h3>
          <p className="auth__text">
            New to Cardplot?{" "}
            <Link to="/getstarted" className="text-decoration-none">
              Sign up
            </Link>
          </p>
          <div className="auth__container__form">
            {errorMessage && <p className="text-center text-danger error-container">{errorMessage}</p>}
            {successMessage && <p className="text-center text-success success-container">{successMessage}</p>}
            <form onSubmit={handleLogin}>
              <div className="form__group mb-4">
                <label htmlFor="email" className="label__form">
                  Your email address
                </label>
                <div className="input-group">
                  <span className="auth__input__group">
                    <MdOutlineMarkEmailRead />
                  </span>
                  <input
                    type="email"
                    name="email"
                    id="email"
                    className="auth__input"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    required
                  />
                </div>
              </div>

              <div className="form__group">
                <label htmlFor="password" className="label__form">
                  Your password
                </label>
                <div className="input-group">
                  <span className="auth__input__group">
                    <TbLockCheck />
                  </span>
                  <input
                    type={passwordType}
                    name="password"
                    id="password"
                    className="auth__input"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    required
                  />
                  <span
                    className="auth__input__group end__0" role="button"
                    onClick={togglePasswordVisibility}
                  >
                    {passwordType === "password" ? <IoMdEyeOff /> : <IoEye />}
                  </span>
                </div>
              </div>

              <div className="mb-4 mt-2">
                <Link to="/password-reset" className="forget__password">
                  Having Trouble logging in?
                </Link>
              </div>

              <div className="form__group">
                <button type="submit" className="btn btn__block mb-4">
                  {isLoading ? (
                    <div className="spinner-border spinner-border-sm text-light" role="status">
                      <span className="visually-hidden">Loading...</span>
                    </div>
                  ) : (
                    "Login"
                  )}
                </button>
              </div>
            </form>

            {/* <div style={{ paddingTop: '30px'}}>
                <p className='auth__text__small text-center'>Or sign in using</p>
            </div> */}

            {/* <div className="social__account">
              <Link className="social__account__box"> 
                <GoogleAuth userAction={'login'} setIsLoading={setIsLoading} />
              </Link> */}
              {/* <Link className="social__account__box">
                <FaFacebook className="social__account__icon" />
              </Link>
              <Link className="social__account__box">
                <FaApple className="social__account__icon last" />
              </Link> */}
            {/* </div> */}
          </div>
        </div>
      </div>
    </div>
  );
}

export default Login;